const TRUSTED_ORIGINS = [
    'https://todoist.com',
    'https://app.todoist.com',
    'https://beta.todoist.com',
    'https://staging.todoist.com',
    'https://local.todoist.com',
    'https://mail.google.com',
]

export function isTrustedOrigin(origin: string): boolean {
    const extensionOrigin = new URL(chrome.runtime.getURL('')).origin
    return TRUSTED_ORIGINS.includes(origin) || origin === extensionOrigin
}
